import {QUERY_STORAGE_KEYS} from "~/constants/queries";
import {queryClient} from "~/plugins/vue-query";

export const STORAGE_KEY_PREFIX = 'vue-query:'

export function clearStoredQueries() {
    for (const { key, storage, persistOnLogout } of QUERY_STORAGE_KEYS) {
        const storageRef = storage === 'localStorage' ? localStorage : sessionStorage
        const storageKey = STORAGE_KEY_PREFIX + JSON.stringify(key)
        if (!persistOnLogout) {
            try {
                queryClient.removeQueries({queryKey: key})
                storageRef.removeItem(storageKey)
            } catch (error) {
                console.error(`Failed to remove ${storageKey} from ${storage}`, error)
            }
        }
    }
}
